import type { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import { useMe } from '../api/hooks'

/** Пускает дальше только залогиненного. Пока проверяем — ничего не мигает. */
export default function RequireAuth({ children }: { children: ReactNode }) {
  const { data: user, isLoading } = useMe()
  const loc = useLocation()

  if (isLoading) return <div className="main"><div className="skeleton" style={{ maxWidth: 260 }} /></div>
  if (!user) return <Navigate to="/login" replace state={{ from: loc.pathname }} />
  return <>{children}</>
}
